import { useEffect, useState } from 'react';

import { getReferenceData, getConsignees, getConsignors, getCarriers, getDeclarant } from '../../../api/util';

const useReferenceData = (companyId) => {
  const [referenceData, setReferenceData] = useState({});
  const [consignees, setconsignees] = useState([]);
  const [consignors, setConsignors] = useState([]);
  const [carriers, setCarriers] = useState([]);
  const [declarant, setDeclarant] = useState(null);

  const refDatas = [
    'modeOfTransport',
    'packageTypes',
    'ports?entryport=true',
    'ports',
    'countryOfOrigin',
    'getDocumentType',
    'charges',
    'transportTypes?isActive=1',
    'transportTypes?isActive=0',
    'equipmentTypes',
    'unDangerousGoods',
  ];

  useEffect(() => {
    const fetchData = async () => {
      const consignors = await getConsignors(companyId);
      const consignees = await getConsignees(companyId);
      const carriers = await getCarriers(companyId);
      const declarant = await getDeclarant(companyId);
      setconsignees(consignees);
      setConsignors(consignors);
      setCarriers(carriers);
      setDeclarant(declarant);

      setReferenceData((prev) => ({
        ...prev,
        consignees,
        consignors,
        carriers,
        declarant,
      }));
      //update referenceData, adding consignors and consignees
    };

    // ensuring data is only fetched once rest of referenceData has initialized
    if (
      companyId &&
      Object.keys(referenceData).length &&
      !referenceData.consignees &&
      !referenceData.consignors &&
      !referenceData.carriers &&
      !referenceData.declarant
    ) {
      fetchData();
    }
  }, [companyId, referenceData]);

  const retrieveReferenceData = async () => {
    const refData = {};
    for (const element of refDatas) {
      const data = await getReferenceData(element);
      if (element.includes('transportTypes')) {
        const mappedData = data.map((d) => {
          return { key: d.transportTypeId, value: d.transportTypeName };
        });
        // Determine if the transport type is active or passive based on the element name
        const elementName = element.includes('isActive=1') ? 'transportTypesActive' : 'transportTypesPassive';
        refData[elementName] = mappedData;
      } else if (element === 'getDocumentType') {
        const mappedData = data.map((d) => {
          return { key: d.id, value: d.documentTypeDescription };
        });
        refData[element] = mappedData;
      } else if (element === 'unDangerousGoods') {
        const mappedData = data.map((d) => {
          const formattedCode = d.code.toString().padStart(4, '0'); // format as 4 digits with leading zeros
          return {
            key: formattedCode,
            value: `${formattedCode} - ${d.description}`,
          };
        });
        refData['unDangerousGoods'] = mappedData;
      } else if (element !== 'countryOfOrigin' && !element.includes('ports') && element !== 'packageTypes') {
        const mappedData = data.map((d) => {
          const keys = Object.keys(d);
          return { key: d[keys[0]], value: d[keys[1]] };
        });
        refData[element] = mappedData;
      } else if (element === 'packageTypes') {
        const mappedData = data.map((d) => {
          return {
            key: d.id,
            value: d.data,
            piecesRequired: d.piecesRequired,
            disablePiecesRequired: d.disablePiecesRequired,
          };
        });
        refData['packageTypes'] = mappedData;
      } else if (element.includes('ports')) {
        const mappedData = data.map((d) => {
          const keys = Object.keys(d);
          return { key: d[keys[0]], value: d[keys[1]] };
        });
        if (element.includes('true')) refData['entryPorts'] = mappedData;
        else refData['exitPorts'] = mappedData;
      } else if (element === 'countryOfOrigin') {
        const mappedDataId = data.map((d) => {
          return { key: d.id, value: d.countryName, isEU: d.isEU };
        });
        refData['countryOfOriginId'] = mappedDataId;
        const mappedDataCC = data.map((d) => {
          return { key: d.countryCode, value: d.countryName, isEU: d.isEU };
        });
        refData['countryOfOriginCC'] = mappedDataCC;
        const mappedDataMap = data.map((d) => {
          return { key: d.id, value: d.countryCode, isEU: d.isEU };
        });
        refData['countryOfOriginMap'] = mappedDataMap;
      }
    }
    refData['packagesWithPiecesRequired'] = refData?.packageTypes?.filter((p) => p.piecesRequired).map((p) => p.key);
    refData['packagesWithPiecesDisabled'] = refData?.packageTypes
      ?.filter((p) => p.disablePiecesRequired)
      .map((p) => p.key);
    //update referenceData with the new data, but keep the old data as well
    setReferenceData((prev) => ({ ...prev, ...refData }));
  };

  useEffect(() => {
    retrieveReferenceData();
  }, []);

  const refreshNeenors = async () => {
    setReferenceData((prev) => ({
      ...prev,
      consignees,
      consignors,
      carriers,
      declarant,
    }));
  };

  return { referenceData, refreshNeenors };
};

export default useReferenceData;
